"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTestEnv = exports.getEnvStage = exports.getEnvBrand = exports.demandEnv = void 0;

var errors_1 = require("../errors");

var types_1 = require("../types");
/**
 * Environment flag to ignore required env variables
 */


var IS_DEBUG = process.env.RBI_DEBUG === '1';
/**
 * Demand an environment variable be present.
 *
 * If the environment variable `RBI_DEBUG` is set then only warn.
 *
 * @param {String} key
 * The key of the environment variable.
 *
 * @param {String} defaultValue
 * An optional default in the event the environment variable does not exist.
 *
 * @throws {Error}
 * Thrown if the environment variable does not exist.
 *
 * @returns {String}
 * The required environment variable is returned.
 */

function demandEnv(key, defaultValue) {
  var value = process.env[key] || defaultValue;

  if (value === undefined) {
    if (!IS_DEBUG) {
      throw new Error("Environment variable ".concat(key, " is required."));
    } else {
      // eslint-disable-next-line no-console
      console.warn("DEBUG MODE. Ignoring missing env var \"".concat(key, "\""));
    }
  }

  return value;
}

exports.demandEnv = demandEnv;
/**
 * Interrogate the environment for the configured Brand.
 *
 * @throws {Error}
 * Thrown if the environment variable is missing altogether.
 *
 * @throws {UnknownBrandError}
 * Thrown if the environment is not configured with a known Brand.
 *
 * @returns {Brand}
 * The Brand configured in the environment is returned.
 */

function getEnvBrand() {
  var brand = demandEnv('BRAND').toUpperCase();

  if (!(brand in types_1.Brand)) {
    throw new errors_1.UnknownBrandError(brand);
  }

  return brand;
}

exports.getEnvBrand = getEnvBrand;
/**
 * Interrogate the environment for the configured Stage.
 *
 * @param {Object} options
 * * preserveSandboxes - Specify true to retain sandbox-* and not convert to localdev.
 *
 * @throws {Error}
 * Thrown if the environment variable is missing altogether.
 *
 * @throws {UnknownStageError}
 * Thrown if the environment is not configured with a known Stage.
 *
 * @returns {Stage}
 * The Stage configured in the environment is returned.
 */

function getEnvStage() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$preserveSandboxe = _ref.preserveSandboxes,
      preserveSandboxes = _ref$preserveSandboxe === void 0 ? false : _ref$preserveSandboxe;

  var stage = (process.env.STAGE || demandEnv('NODE_ENV')).toLowerCase();

  if (stage.includes('sandbox-')) {
    return preserveSandboxes ? stage : types_1.Stage.localdev;
  }

  if (!(stage in types_1.Stage)) {
    throw new errors_1.UnknownStageError(stage);
  }

  return stage;
}

exports.getEnvStage = getEnvStage;
/**
 * Return true if the current environment was initiated by the test runner.
 *
 * @returns {boolean} is test environmet
 */

function isTestEnv() {
  return !!process.env.JEST_WORKER_ID;
}

exports.isTestEnv = isTestEnv;